<template lang="pug">
div.card(v-if="typeof editable_creative != 'undefined' ")
  div.card-header
    h3.card-title クリエイティブ編集
  div.card-body
    section#creative_edit_wrap
      div.form-group
        label(for='creative_title') タイトル
        input#creative_edit_title.form-control(type='text',
        name='title',
        placeholder='タイトルを入力',
        @input='setTitle',
        @blur='$v.title.$touch',
        :value="title",
        :class="{ 'is-invalid': $v.title.$invalid && $v.title.$dirty, 'is-valid': !$v.title.$invalid && $v.title.$dirty }")
        .invalid-feedback(v-if="!$v.title.required && $v.title.$dirty") 入力してください
      div.form-group
        label 画像タイプ
        div.form-group
          label.form-check-label(for='creative_image_is_url')
            input#creative_image_is_url.mr-1(type='radio',
              name='is_upload_image',
              :checked="is_upload_image === 0",
              @change='setIsUploadImage',
              value="0",
            )
            | URL
          label.form-check-label.ml-3(for='creative_image_is_is_upload')
            input#creative_image_is_is_upload.mr-1(type='radio',
              name='is_upload_image',
              :checked="is_upload_image === 1",
              @change='setIsUploadImage',
              value="1",
            )
            | アップロード

      div.form-group(v-if="is_upload_image == 0")
        label(for='creative_image_url') URL
        input#creative_edit_image_url.form-control(type='text',
        name='image', placeholder='画像のURLを入力',
        @input='setImage',
        @blur='$v.image.$touch',
        :value="image",
        :class="{ 'is-invalid': $v.image.$invalid && $v.image.$dirty, 'is-valid': !$v.image.$invalid && $v.image.$dirty }")
        template(v-if="$v.image.$dirty")
          .invalid-feedback(v-if="!$v.image.required") 入力してください
          .invalid-feedback(v-if="!$v.image.url") URL形式が正しくありません
      div.form-group(v-if="is_upload_image == 1")
        label(for='creative_image_upload') 画像アップロード
          div
            input#creative_image_upload(type='file',
              accept='.jpg,.jpeg,.gif,.png,.webp',
              name='upload_image'
              @change="setUploadImageFile")
            template(v-if="$v.upload_image && $v.upload_image.$dirty")
              .invalid-feedback(v-if="is_upload_image == 1 && !$v.upload_image.required") ファイルを選択してください
      div.form-group
        label(for='creative_link') リンク先URL
        input#creative_edit_link.form-control(type='text',
        name='link',
        placeholder='リンク先のURLを入力',
        @input='setLink',
        :value="link",
        @blur='$v.link.$touch',
        :class="{ 'is-invalid': $v.link.$invalid && $v.link.$dirty, 'is-valid': !$v.link.$invalid && $v.link.$dirty }")
        template(v-if="$v.link.$dirty")
          .invalid-feedback(v-if="!$v.link.required") 入力してください
      div.form-check
        input#creative_edit_pr.form-check-input(type='checkbox', name='pr', @change='setPrFlag', :checked="pr_flag", value=1)
        label.form-check-label(for='creative_pr') PR を表示
  div.card-footer
    button.btn.btn-primary.submit-action(type='submit', @click='submit', :class="{ 'disabled': $v.$invalid }") 更新する
    button.btn.btn-default(@click='back') キャンセル
</template>

<script>
import Vue from "vue";

import { required, url } from "vuelidate/lib/validators";

import { mapState } from "vuex";

export default {
  props: {
    widget_id: String,
  },
  methods: {
    setTitle(e) {
      this.$store.commit("creative/setEditListTitle", e.target.value);
    },
    setIsUploadImage(e) {
      this.$store.commit("creative/setEditListIsUploadImage", Number(e.target.value));
    },
    setImage(e) {
      this.$store.commit("creative/setEditListImage", e.target.value);
    },
    setLink(e) {
      this.$store.commit("creative/setEditListLink", e.target.value);
    },
    setPrFlag(e) {
      this.$store.commit("creative/setEditListPrFlag", e.target.checked);
    },
    setUploadImageFile(e) {
      // ファイルが選択されたときの処理
      const file = e.target.files[0];
      if (file) {
        this.$store.commit("creative/setEditListUploadImage", file);
        // FileReader を使用してデータURLに変換
        const reader = new FileReader();
        reader.onload = () => {
          // プレビュー用のデータURLをセット
          this.$store.commit("creative/setEditListUploadImagePath", reader.result);
        };
        reader.readAsDataURL(file);
      }
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        //送信処理
        this.$v.$reset();
        const data = await this.$store.dispatch(
          "creative/find_edit_mode_and_update"
        );
        this.$toasted.success("クリエイティブを更新しました");
        await sleep(10000);
        this.$toasted.clear();
      }
    },
    back() {
      this.$store.commit(
        "creative/clearEditMode",
        this.$store.getters["creative/findEdit"]
      );
    },
  },
  async mounted() {
    await Vue.nextTick();
    this.$store.commit("creative/setPreviewListWidgetId", this.widget_id);
  },
  computed: {
    title() {
      return this.$store.getters["creative/findEdit"].title;
    },
    is_upload_image() {
      return this.$store.getters["creative/findEdit"].is_upload_image ?? 0;
    },
    image() {
      return this.$store.getters["creative/findEdit"].image;
    },
    link() {
      return this.$store.getters["creative/findEdit"].link;
    },
    pr_flag() {
      return this.$store.getters["creative/findEdit"].pr_flag;
    },
    editable_creative() {
      return this.$store.getters["creative/findEdit"];
    },
  },
  validations: {
    title: {
      required,
    },
    image: {
      required,
      url,
    },
    link: {
      required,
    },
  },
};
</script>
<style lang="scss" scoped>
.submit-action {
  margin-right: 10px;
}
</style>
